import { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";
import WizardNav from "./WizardNav";

export const WizardNavRootContext = createContext(null);

const StepPanel = ({
	stepNumber,
	title,
	description,
	children,
	nav,
	status = null,
}) => {
	const navRoot = useContext(WizardNavRootContext);

	return (
		<section
			className="animate-fade-in-up space-y-4 w-full min-w-0 max-w-xl"
			aria-labelledby={`bulk-step-${stepNumber}-title`}
		>
			<header className="space-y-1">
				<p className="text-xs font-semibold uppercase tracking-widest text-akgreen">
					Step {stepNumber} of 4
				</p>
				<h2
					id={`bulk-step-${stepNumber}-title`}
					className="text-lg font-semibold tracking-tight text-akgreenest sm:text-xl"
				>
					{title}
				</h2>
				{description ? (
					<p className="max-w-2xl text-sm leading-snug text-gray-600">
						{description}
					</p>
				) : null}
			</header>
			{status}
			<div>{children}</div>

			{nav && navRoot ? createPortal(<WizardNav {...nav} />, navRoot) : null}
		</section>
	);
};

/**
 * Renders the sticky card footer slot and provides it to StepPanel via context.
 * Children scroll independently; WizardNav portals into the footer.
 */
export const WizardNavHost = ({ children }) => {
	const [node, setNode] = useState(null);

	return (
		<WizardNavRootContext.Provider value={node}>
			<div className="flex min-h-0 flex-1 flex-col overflow-hidden">
				{children}
				<div
					ref={setNode}
					className="flex-shrink-0 border-t border-gray-200 bg-white px-5 py-3 sm:px-8"
				/>
			</div>
		</WizardNavRootContext.Provider>
	);
};

export default StepPanel;
